(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './fonts'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./fonts'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.fonts);
    global.fonts = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.pjFontSize15 = exports.pjFontSize14 = exports.pjFontSize13 = exports.pjFontSize12 = exports.pjFontSize11 = exports.pjFontSize10 = exports.pjFontSize09 = exports.pjFontSize08 = exports.pjFontSize07 = exports.pjFontSize06 = exports.pjFontSize05 = exports.pjFontSize04 = exports.pjFontSize03 = exports.pjFontSize02 = exports.pjFontSize01 = exports.pjFontSizeBase = exports.pjFontWeightBold = exports.pjFontWeightSemibold = exports.pjFontWeightNormal = exports.pjFontWeightLight = exports.ProximaNovaSemiBold = exports.ProximaNovaThin = exports.ProximaNovaT = exports.ProximaNovaA = exports.ProximaNova = undefined;


  var fontFallbacks = 'Arial, Helvetica, sans-serif'; // Deprecated
  var ProximaNova = exports.ProximaNova = 'Proxima Nova, ' + fontFallbacks; // Deprecated
  var ProximaNovaA = exports.ProximaNovaA = 'Proxima NovaA, ' + fontFallbacks; // Deprecated
  var ProximaNovaT = exports.ProximaNovaT = 'Proxima NovaT, ' + fontFallbacks; // Deprecated
  var ProximaNovaThin = exports.ProximaNovaThin = 'Proxima Nova Thin, Proxima Nova, ' + fontFallbacks; // Deprecated
  var ProximaNovaSemiBold = exports.ProximaNovaSemiBold = 'Proxima Nova Semi Bold, ProximaNova, ' + fontFallbacks; // Deprecated

  var pjFontWeightLight = exports.pjFontWeightLight = '200';
  var pjFontWeightNormal = exports.pjFontWeightNormal = '400';
  var pjFontWeightSemibold = exports.pjFontWeightSemibold = '600';
  var pjFontWeightBold = exports.pjFontWeightBold = '700';

  var pjFontSizeBase = exports.pjFontSizeBase = 16;

  var pjFontSize01 = exports.pjFontSize01 = pjFontSizeBase - 6 + 'px';
  var pjFontSize02 = exports.pjFontSize02 = pjFontSizeBase - 4 + 'px';
  var pjFontSize03 = exports.pjFontSize03 = pjFontSizeBase - 2 + 'px';
  var pjFontSize04 = exports.pjFontSize04 = pjFontSizeBase + 'px';
  var pjFontSize05 = exports.pjFontSize05 = pjFontSizeBase + 2 + 'px';
  var pjFontSize06 = exports.pjFontSize06 = pjFontSizeBase + 4 + 'px';
  var pjFontSize07 = exports.pjFontSize07 = pjFontSizeBase + 6 + 'px';
  var pjFontSize08 = exports.pjFontSize08 = pjFontSizeBase + 8 + 'px';
  var pjFontSize09 = exports.pjFontSize09 = pjFontSizeBase + 10 + 'px';
  var pjFontSize10 = exports.pjFontSize10 = pjFontSizeBase + 12 + 'px';
  var pjFontSize11 = exports.pjFontSize11 = pjFontSizeBase + 14 + 'px';
  var pjFontSize12 = exports.pjFontSize12 = pjFontSizeBase + 16 + 'px';
  var pjFontSize13 = exports.pjFontSize13 = pjFontSizeBase + 18 + 'px';
  var pjFontSize14 = exports.pjFontSize14 = pjFontSizeBase + 20 + 'px';
  var pjFontSize15 = exports.pjFontSize15 = pjFontSizeBase + 22 + 'px';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/styles/fonts/fonts.js
// module id = 84
// module chunks = 0